<template>
    <button class="sc-user-input--button-icon-wrapper" :disabled="disabled">
        <span class="material-icons sendIcon" v-if="newIcon"> send </span>
        <icon-base :color="color" :icon-name="tooltip" height="20" width="20" v-else>
            <slot />
        </icon-base>
    </button>
</template>

<script>
import IconBase from "./components/IconBase.vue";

export default {
    props: {
        color: {
            type: String,
            required: true,
        },
        tooltip: {
            type: String,
            required: false,
            default: "",
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        newIcon: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    components: {
        IconBase,
    },
};
</script>

<style scoped lang="scss">
.sc-user-input--button-icon-wrapper {
    background: none;
    border: none;
    padding: 0px;
    margin: 0px;
    outline: none;
    cursor: pointer;

    & :focus {
        outline: none;
    }

    svg {
        height: 20px;
        width: 20px;
        cursor: pointer;
        align-self: center;
        outline: none;

        & :hover path {
            filter: contrast(15%);
        }
    }
}

section.footer {
    .sc-user-input-wrapper {
        .sendIcon {
            color: rgb(18, 91, 251);
        }

        &.disabled {
            .sendIcon {
                color: #c4c7c9;
                cursor: not-allowed;
            }
        }
    }
}
</style>
